import React, { useEffect, useState } from "react";
import "./Newsletter.css";
import image from "../../assets/Group 14 (1).png";
import axios from "axios";
import Swal from "sweetalert2";

const API_KEY = process.env.REACT_APP_API_KEY;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://api.kit.com/v4/subscribers",
        {
          first_name: name,
          email_address: email,
          state: "active",
          fields: {
            phone_number: phone,
            source: "landing page",
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Kit-Api-Key": API_KEY,
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        setEmail("");
        setName("");
        setPhone("");
        Swal.fire({
          title: "Thank You!",
          text: "You have successfully subscribed to our newsletter!",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong, please try again!",
          icon: "error",
        });
      }
    }catch (error: any) {
        console.error("API Error:", error.response?.data || error.message);
    }
      
  };

  return (
    <div className="newsletter-container">
      <div className="newsletter-header-container">
        <div className="newsletter-header">Subscribe to our newsletter</div>
        <div className="newsletter-subheader">
          Your monthly dose of art and culture. Don't miss what's coming next!
        </div>
      </div>
      <div className="image-background">
        <div className="newsletter-card">
          <h1 className="newsletter-title">Newsletter</h1>
          <p className="newsletter-paragraph">
            Do not miss your chance to know more about our events and services.
            Subscribe now!
          </p>
          <div className="newsletter-input">
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="name-input"
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="email-input"
            />
            <input
              type="tel"
              placeholder="Phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              className="phone-input"
            />
            <button className="subscribe-button" onClick={handleSubmit}>
              Subscribe
            </button>
            <p className="newsletter-sub-paragraph">
            We respect your privacy. You can unsubscribe at any time.
          </p>
          </div>
        </div>
      </div>
      <div className="diagonal-overlay">
        <img src={image} alt="" style={{ width: "100%", height: "100%" }} />
      </div>
    </div>
  );
};

export default Newsletter;
